import { EventEmitter } from '@angular/core';
import { UtilsService } from 'Angular/services/core/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/utils.service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i3 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i4 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
export class PershingActivateModalComponent {
    constructor(utilsService) {
        this.utilsService = utilsService;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.EMAIL_TEMPLATE = 'Hello,\n\nI’d like to request to set up the Pershing integration with YCharts. ' +
            'Can you please help with initiating that process by submitting a Project Request Form?';
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.closeModalHandler.emit();
    }
    onClick() {
        this.utilsService.copyToClipboard(this.EMAIL_TEMPLATE);
    }
}
PershingActivateModalComponent.ɵfac = function PershingActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PershingActivateModalComponent)(i0.ɵɵdirectiveInject(i1.UtilsService)); };
PershingActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PershingActivateModalComponent, selectors: [["ycn-pershing-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, decls: 28, vars: 5, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "modal-message"], ["type", "1"], ["href", "javascript:void(0);", 1, "text-blue", 3, "click"], ["href", "/contact_us", 1, "text-blue"], ["disabled", "1", "rows", "4", 2, "width", "100%", "white-space", "pre-wrap", "resize", "none"], [3, "cancelHandler", "submitHandler", "showSubmitButton"]], template: function PershingActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function PershingActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function PershingActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "p")(6, "strong");
        i0.ɵɵtext(7, "To connect your Pershing integration to YCharts, please complete the following steps:");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "ol", 5)(9, "li");
        i0.ɵɵtext(10, "User should request the integration through their Pershing Relationship Manager.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "li");
        i0.ɵɵtext(12, "Pershing Relationship Manager will submit a Project Request Form internally.");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "p");
        i0.ɵɵtext(14, "Once they provide us with the necessary credentials, you\u2019ll be able to import holdings from Pershing.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p");
        i0.ɵɵtext(16, "For convenience, please click ");
        i0.ɵɵelementStart(17, "a", 6);
        i0.ɵɵlistener("click", function PershingActivateModalComponent_Template_a_click_17_listener() { return ctx.onClick(); });
        i0.ɵɵtext(18, "here");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(19, " to copy the below message to paste into your email to your Relationship Manager.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "p");
        i0.ɵɵtext(21, "Still need assistance? Feel free to ");
        i0.ɵɵelementStart(22, "a", 7);
        i0.ɵɵtext(23, " contact your YCharts Customer Support Representative");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(24, " to answer any questions about the integration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "textarea", 8);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(27, "ycn-simple-modal-footer", 9);
        i0.ɵɵlistener("cancelHandler", function PershingActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_27_listener() { return ctx.closeModal(); })("submitHandler", function PershingActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_27_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate Pershing Integration");
        i0.ɵɵadvance(25);
        i0.ɵɵtextInterpolate(ctx.EMAIL_TEMPLATE);
        i0.ɵɵadvance();
        i0.ɵɵproperty("showSubmitButton", false);
    } }, dependencies: [i2.ModalBaseComponent, i3.SimpleModalFooterComponent, i4.SimpleModalHeaderComponent], encapsulation: 2 });
